export enum WiseOwlZendeskRealm {
  local = "local",
  sandbox = "sandbox",
  prod = "prod",
}

export interface TicketConversationAttachment {
  contentType: string;
  contentUrl: string;
  filename: string;
}

export interface TicketConversationAuthor {
  id?: number;
  name: string;
  role: string;
}

export interface TicketConversationChannel {
  name: string;
}

export interface TicketConversationMessage {
  content?: string;
  contentType?: string;
}

// https://developer.zendesk.com/api-reference/apps/apps-support-api/ticket_sidebar/#ticketconversation
export interface TicketConversation {
  attachments: TicketConversationAttachment[];
  author: TicketConversationAuthor;
  channel: TicketConversationChannel;
  message: TicketConversationMessage;
  timestamp: string;
}

// https://developer.zendesk.com/api-reference/apps/apps-support-api/ticket_sidebar/#ticket-object
export interface ZendeskSidebarTicket {
  id?: number;
  subject: string;
  conversation: TicketConversation[];
}
